import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Auth0UiService } from 'avn/modules/services/auth0-serv.service';
import { StoreService } from 'avn/modules/services/store.service';
import { Location } from 'avn/modules/shared/interfaces/homepage';

@Component({
  selector: 'app-home',
  templateUrl: './home.html',
  styleUrls: ['./home.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit {
  public meraLocation = new Location();

  public constructor(
    private readonly store: StoreService,
    private readonly auth0: Auth0UiService,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.auth0.loginCheck('/');
  }

  public ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.store.meraLocationSub.subscribe((location: Location) => {
        this.meraLocation = location;
        const service = localStorage.getItem('service') ?? 'health-and-wellbeing-services';
        void this.router.navigate([`/browse/${service}`]);
        this.cdr.markForCheck();
      });
    }
  }
}
